import React, { Component } from 'react'
import { connect } from 'react-redux'
import styles from '../../styles/common/progLangList.module.css'
import progLanguages from '../../constants/common/ProgLanguages'
import ProgLangListHeader from './ProgLangListHeader'
import ProgLangListItem from './ProgLangListItem'
import { toggleProgLangList } from '../../actions/commonActions'


export class ProgLangList extends Component {
    constructor(props) {
        super(props);

        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target) && this.props.isOpen) {
            this.props.toggleProgLangList(this.props.featureId);
        }
    }

    renderItems() {
        if(this.props.isOpen) {
            return (
                <div className={styles.container}>
                    {progLanguages.map(progLang => {
                        return progLang.id !== this.props.selection ? <ProgLangListItem progLang={progLang} /> : null;
                    })}
                </div>
            )
        }
        return null
    }

    render() {
        return (
            <div ref={this.wrapperRef}>
                <ProgLangListHeader />
                {this.renderItems()}
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { selection, isOpen } = state.common.progLangList;
    return { selection, isOpen };
}

export default connect(mapStateToProps, {toggleProgLangList})(ProgLangList)
